export default {
  text: 'Ansaitset <highlight>{{value}} pistettä</highlight> tällä tilauksella',
};
